// 💾 src/pages/client/sections/components/Profile/Referral.tsx
import { useEffect, useState } from "react"
import { auth, db } from "../../../../../services/firebase"
import { doc, getDoc } from "firebase/firestore"
import "./style/Referral.scss"

const Referral = () => {
  const user = auth.currentUser
  const [referralCode, setReferralCode] = useState("")
  const [referralLink, setReferralLink] = useState("")
  const [copyMsg, setCopyMsg] = useState("")

  useEffect(() => {
    if (user) {
      const code = user.uid.slice(0, 6)
      setReferralCode(code)
      setReferralLink(`${window.location.origin}/register?ref=${code}`)
    }
  }, [user])

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text)
    setCopyMsg("Copied!")
    setTimeout(() => setCopyMsg(""), 2000)
  }

  return (
    <div className="referral-page">
      <h2>Invite Friends & Earn Rewards</h2>

      <div className="ref-summary">
        <h3>My Referral Program</h3>
        <p>Share and earn commissions on trading fees of your referrals.</p>

        <div className="ref-stats">
          <div className="stat">
            <strong>Referral Code:</strong>
            <span>{referralCode}</span>
            <button onClick={() => handleCopy(referralCode)}>📋</button>
          </div>
          <div className="stat">
            <strong>Referral Link:</strong>
            <input value={referralLink} readOnly />
            <button onClick={() => handleCopy(referralLink)}>📋</button>
          </div>
          {copyMsg && <div className="copied-msg">{copyMsg}</div>}
        </div>
      </div>

      <div className="ref-steps">
        <h4>How to Refer and Earn</h4>
        <div className="steps">
          <div>🔗 Share Code or Link</div>
          <div>👥 User Signs Up</div>
          <div>💸 Earn Commission</div>
        </div>
      </div>

      <div className="ref-history">
        <h4>My Invites</h4>
        <table>
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Joined</th>
              <th>Commission</th>
            </tr>
          </thead>
          <tbody>
            <tr>
             <td colSpan={4}>There is no invites...</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="ref-rules">
        <h4>Referral Commission Rules</h4>
        <ol>
          <li>
            Every registered user gets a referral code and link.
          </li>
          <li>
            When someone signs up using your code, they are marked as your referral.
          </li>
          <li>
            You earn a % commission on their trading fees.
          </li>
          <li>
            All rewards are credited to your account weekly.
          </li>
        </ol>
      </div>
    </div>
  )
}

export default Referral
